<template>
  <div>
    <CustomAlert :show-alert="submitError" alert-type="error">
      <span class="body-2">{{ submitErrorMsg }}</span>
    </CustomAlert>
    <v-row class="align-center">
      <v-col cols="3">
        <v-btn color="primary" @click="refresh"
          ><v-icon>mdi-refresh</v-icon>
          {{ $cmsService.getContent(content, 'refresh') }}</v-btn
        >
      </v-col>
      <v-col cols="9">
        <TimePicker />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-card>
          <v-card-text class="pa-0">
            <v-data-table
              v-model="selectedRuleObject"
              :loading="loadingRulesListTableData"
              single-select
              item-key="id"
              calculate-widths
              :headers="headersRulesList"
              :items="rulesList"
              hide-default-footer
            >
              <template #item="props">
                <tr
                  :class="[
                    props.isSelected ? '__selected' : '',
                    props.item.ruleName === allRuleName ? '__allRule' : ''
                  ]"
                  @click="rowClick(props)"
                >
                  <td>
                    <v-chip
                      :color="props.item.documents > 0 ? 'success' : ''"
                      :class="props.isSelected ? 'darken-2' : ''"
                      >{{ props.item.documents }}</v-chip
                    >
                  </td>
                  <td>
                    <v-chip
                      :color="props.item.sheetAmount > 0 ? 'success' : ''"
                      :class="props.isSelected ? 'darken-2' : ''"
                      >{{ props.item.sheetAmount }}</v-chip
                    >
                  </td>
                  <td>{{ props.item.ruleName }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center"
            ><RuleConfiguration
              :preselected-rule="
                selectedRule
                  ? selectedRule.ruleName === allRuleName
                    ? ''
                    : selectedRule.ruleName
                  : ''
              "
              @saved="reset"
            ></RuleConfiguration
          ></v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-data-table
          :loading="loadingTableData"
          :footer-props="{
            'items-per-page-text': 'Datensätze pro Seite',
            'items-per-page-all-text': 'Alle',
            'page-text': '{0}-{1} von {2}'
          }"
          :headers="headers"
          :items="items"
          :items-per-page="10"
          :height="500"
          class="elevation-1"
          sort-by="leadRegion"
        >
          <template #top
            ><v-card flat
              ><v-card-text
                ><v-checkbox
                  v-model="allChecked"
                  hide-details
                  class="mt-0 pr-2 justify-end"
                  color="primary"
                  :label="` ${allChecked ? 'alle' : 'keine'} ausgewählt`"
                  @change="toggleAllCheckboxes()"
                ></v-checkbox></v-card-text></v-card
          ></template>
          <template #footer>
            <v-divider></v-divider>
            <v-chip-group
              v-if="selectedRule && selectedRule.ruleName !== allRuleName"
              v-model="chipRules"
              column
              multiple
              active-class="primary--text"
              class="pl-2"
            >
              <div
                v-for="(ruleObj, index) in Object.keys(selectedRule)"
                :key="index"
                @click="fetchProductionData()"
              >
                <v-chip
                  v-if="
                    ruleObj !== 'id' &&
                    ruleObj !== 'ruleName' &&
                    ruleObj !== 'ignoreAllFilters'
                  "
                  filter
                  :value="ruleObj"
                >
                  {{
                    $cmsService.getContent(
                      content,
                      capitalizeFirstLetter(ruleObj)
                    )
                  }}:
                  {{
                    ruleObj !== 'selectedRegions'
                      ? getEnumsContent(
                          capitalizeFirstLetter(ruleObj),
                          selectedRule[ruleObj]
                        )
                      : ''
                  }}
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-icon
                        v-if="ruleObj === 'selectedRegions'"
                        v-bind="attrs"
                        right
                        v-on="on"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>{{ selectedRule[ruleObj] }}</span>
                  </v-tooltip>
                </v-chip>
              </div>
            </v-chip-group></template
          >
          <template #[`item.leadRegion`]="{ item }">
            <span v-html="item.leadRegion"></span>
          </template>
          <template #[`item.sheetAmount`]="{ item }">
            <span v-html="item.sheetAmount"></span>
          </template>
          <template #[`item.pageAmount`]="{ item }">
            <span v-html="item.pageAmount"></span>
          </template>
          <template #[`item.weight`]="{ item }">
            <span v-html="item.weight + ' g'"></span>
          </template>
          <template #[`item.fullBatches`]="{ item }">
            <span v-html="item.fullBatches"></span>
          </template>
          <template #[`item.checked`]="{ item }">
            <v-checkbox
              v-model="item.checked"
              class="justify-end"
              color="primary"
              @change="updateItemsToBeSent"
            ></v-checkbox>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { planningService, rulesService } from '@/services/'
import { ColorMode } from '@/enums/ColorMode'
import CustomAlert from '@/components/CustomAlert'
import RuleConfiguration from '@/components/forms/RuleConfiguration'
import TimePicker from '@/components/production/TimePicker'
import { EnumBaseMixin } from '@/enums/EnumBaseMixin'
import formContentJson from '@/data/json/forms/ProductionInformation.json'
import productionReadyTableJson from '@/data/json/tables/productionReadyTable.json'
export default {
  components: {
    CustomAlert,
    RuleConfiguration,
    TimePicker
  },
  mixins: [EnumBaseMixin],
  data: vm => ({
    content: productionReadyTableJson.data.concat(formContentJson.data),
    items: [], // DataTable-Items
    allChecked: true, // indicator for items-checked
    submitError: false,
    submitErrorMsg: '',
    selectedRuleObject: [], // Model-Object for RulesListDataTable
    rulesList: [], // RulesList for RulesListDataTable with all rules
    selectedRule: {}, // The selectedRule
    defaultChipRules: [
      'id',
      'ruleName',
      'colorMode',
      'coverType',
      'foldType',
      'frankingType',
      'hasOnlyFullBatches',
      'isRialtoCapable',
      'isWithSupplement',
      'isWithInternational',
      'letterType',
      'paperType',
      'printMode',
      'selectedRegions'
    ], //default chip-rules, for restoring or resetting chipRules
    chipRules: [
      'id',
      'ruleName',
      'colorMode',
      'coverType',
      'foldType',
      'frankingType',
      'hasOnlyFullBatches',
      'isRialtoCapable',
      'isWithSupplement',
      'isWithInternational',
      'letterType',
      'paperType',
      'printMode',
      'selectedRegions'
    ], //selected rules as chips
    loadingTableData: false,
    loadingRulesListTableData: false,
    allRuleName: vm.$cmsService.getContent(
      productionReadyTableJson.data,
      'AllRule'
    ) // RuleName for 'ALL'
  }),
  computed: {
    // trigger when chipRules changed (selected, deselected)
    filteredRules: function () {
      // return allRule directly, no need for filterung
      if (this.selectedRule.ruleName === this.allRuleName)
        return this.selectedRule
      let filteredRule = {}
      if (!Object.keys(this.selectedRule).length) return filteredRule
      for (const [ruleElement, ruleValue] of Object.entries(
        this.selectedRule
      )) {
        this.chipRules.forEach(chipRule => {
          if (ruleElement.includes(chipRule)) {
            // if colorMode is set to 'All', skip it from the Object because the backend don't have 'All' in the ColorMode-Enum
            ruleElement === 'colorMode' && ruleValue === ColorMode.All
              ? ''
              : (filteredRule[ruleElement] = ruleValue)
          }
        })
      }

      // if selectedRegion are deselected, take all regions from 00 to 99
      if (!this.chipRules.includes('selectedRegions'))
        filteredRule.selectedRegions = [...Array(100).keys()].map(i =>
          i.toString()
        )
      return filteredRule
    }
  },
  created: function () {
    this.generateHeaders()
    this.generateRulesList()
  },
  methods: {
    rowClick: async function (props) {
      props.select(true)
      if (props.item.ruleName === this.allRuleName) {
        this.selectedRule = props.item.rule
      } else
        this.selectedRule = await rulesService.getRuleByName(
          props.item.ruleName
        )
      this.fetchProductionData(true)
    },
    capitalizeFirstLetter(stringValue) {
      return stringValue.charAt(0).toUpperCase() + stringValue.slice(1)
    },
    toggleAllCheckboxes() {
      this.items.forEach(item => {
        item.checked = this.allChecked
      })
      this.updateItemsToBeSent()
    },
    generateHeaders() {
      this.headers = [
        {
          text: 'Leitregion',
          value: 'leadRegion'
        },
        {
          text: 'Anzahl Sendungen',
          value: 'documents.length',
          align: 'end'
        },
        {
          text: 'Blatt',
          value: 'sheetAmount',
          align: 'end'
        },
        {
          text: 'Seiten',
          value: 'pageAmount',
          align: 'end'
        },
        {
          text: 'Gewicht',
          value: 'weight',
          align: 'end'
        },
        {
          text: 'volle Lose',
          value: 'fullBatches',
          align: 'end'
        },
        {
          text: 'ausgewählt',
          value: 'checked',
          align: 'end'
        }
      ]
      this.headersRulesList = [
        {
          text: 'Snd.',
          value: 'documents'
        },
        {
          text: 'Blatt',
          value: 'sheetAmount'
        },
        {
          text: 'Regel',
          value: 'ruleName'
        }
      ]
    },
    fetchProductionData(loadDefaults = false) {
      if (loadDefaults) {
        // clone object, set default-values into object
        this.chipRules = JSON.parse(JSON.stringify(this.defaultChipRules))
      }
      this.getOrderList(this.filteredRules)
    },
    getOrderList(requestData) {
      this.loadingTableData = true
      this.items = []
      if (!Object.keys(requestData).length) {
        this.loadingTableData = false
        return
      }
      planningService
        .getOrderList(requestData)
        .then(response => {
          response.forEach(element => (element.checked = true))
          this.submitError = false
          this.items = response
          this.updateItemsToBeSent()
        })
        .catch(e => {
          this.submitError = true
          this.submitErrorMsg = this.getError(e.response.status)
        })
        .finally(() => {
          this.loadingTableData = false
        })
    },
    getError: function (errorKey) {
      return this.$store.getters.error({
        errorKey: errorKey,
        route: this.$route.name
      })
    },
    sumUpItems(object, key) {
      return object.reduce((a, b) => a + (b[key] || 0), 0)
    },
    sumUpDocuments(object) {
      return object.reduce((a, b) => a + (b['documents'].length || 0), 0)
    },
    updateItemsToBeSent: function () {
      let reducedItems = {}
      let itemsToBeSent = []
      this.items.forEach(item => {
        if (item.checked) {
          itemsToBeSent.push(item)
        }
      })
      reducedItems.regionsAmount = itemsToBeSent.length
      reducedItems.orderDocumentsAmount = this.sumUpDocuments(itemsToBeSent)
      reducedItems.orderSheetAmount = this.sumUpItems(
        itemsToBeSent,
        'sheetAmount'
      )
      reducedItems.orderWeight = this.sumUpItems(itemsToBeSent, 'weight')
      reducedItems.orderBatches = this.sumUpItems(itemsToBeSent, 'fullBatches')
      reducedItems.orderPartialBatches = this.sumUpItems(
        itemsToBeSent,
        'partialBatches'
      )
      reducedItems.itemsToBeSent = itemsToBeSent
      this.$emit('setOrderValues', reducedItems)
    },
    reset() {
      this.selectedRuleObject = []
      this.selectedRule = {}
      this.items = []
      this.updateItemsToBeSent()
      this.generateRulesList()
    },
    refresh() {
      this.refreshRulesList()
      this.fetchProductionData()
    },
    generateRulesList() {
      this.loadingRulesListTableData = true
      this.rulesList = []
      // get ruleNames
      let rulesNameList = rulesService.getRulesNameList()
      // add 'all'ruleName to list
      rulesNameList.push(this.allRuleName)
      for (const ruleName of rulesNameList) {
        let rule = {}
        if (ruleName === this.allRuleName) {
          rule = this.createAllRule()
          this.selectedRuleObject = [rule]
          this.selectedRule = rule
          this.getOrderList(rule)
        } else {
          // get rule by name
          rule = rulesService.getRuleByName(ruleName)
        }
        // if colorMode == 'All', delete it
        if (rule.colorMode === ColorMode.All) delete rule.colorMode
        planningService
          .getOrderList(rule)
          .then(orderResponse => {
            // sum all sheetAmount
            let sheetAmount = this.sumUpItems(orderResponse, 'sheetAmount')
            // sum all documents
            let documents = this.sumUpDocuments(orderResponse)
            // add to list
            this.rulesList.push({
              id: rule.id,
              ruleName: ruleName,
              documents: documents,
              sheetAmount: sheetAmount,
              rule: rule
            })
          })
          .catch(() => {})
          .finally(() => {
            this.sortRulesList()
            this.loadingRulesListTableData = false
          })
      }
    },
    refreshRulesList() {
      this.loadingRulesListTableData = true
      for (const ruleListElement of this.rulesList) {
        planningService
          .getOrderList(ruleListElement.rule)
          .then(orderResponse => {
            // sum all sheetAmount
            let sheetAmount = this.sumUpItems(orderResponse, 'sheetAmount')
            // sum all documents
            let documents = this.sumUpDocuments(orderResponse)
            // refresh data
            ruleListElement.sheetAmount = sheetAmount
            ruleListElement.documents = documents
          })
          .catch(() => {})
          .finally(() => {
            this.sortRulesList()
            this.loadingRulesListTableData = false
          })
      }
    },
    sortRulesList() {
      this.rulesList.sort(function (a, b) {
        if (a.sheetAmount > b.sheetAmount) return -1
        if (a.sheetAmount < b.sheetAmount) return 1
        return 0
      })
    },
    // create a rule to see all documents without restrictions
    createAllRule() {
      let allRule = {}
      let id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        }
      )
      allRule = {
        id: id,
        ruleName: this.allRuleName,
        selectedRegions: [...Array(100).keys()].map(i =>
          i.toString().padStart(2, '0')
        ),
        ignoreAllFilters: true
      }
      return allRule
    }
  }
}
</script>
<style>
.table-footer-prepend {
  margin-top: -58px;
  height: 58px;
}
.__selected {
  background: var(--v-success-lighten1) !important;
  color: white;
}
.__allRule {
  background: var(--v-secondary-lighten4) !important;
  color: black;
  font-weight: bold;
}
.__selected.__allRule {
  background: var(--v-success-lighten2) !important;
  color: white;
  text-shadow: 0px 0px 1px #000;
}
</style>
